<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="header">
        <fury-breadcrumbs [@fadeInRight]  current="Partner Users List"></fury-breadcrumbs>
      </div>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
            <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
              <img src="../../../assets/img/filter.png" alt="filter"/>
            </button>
            <div class="filteringprt" *ngIf="isShowFilter">
              <form [formGroup]="filterForm">
              <h3 style="margin: 0;">Filter</h3>
              <mat-form-field appearance="outline">
                <mat-label>Search By</mat-label>
                <mat-select formControlName="searchBy">
                  <mat-option *ngFor="let item of searchByValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Search Type</mat-label>
                <mat-select formControlName="searchType">
                  <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="btnprt">
                <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                <button mat-button class="sub-button" (click)="filterChange()">Search</button>
              </div>
            </form>
            </div>
          </div>
        <div class="actions">
          <button class="create"  type="button" mat-mini-fab color="primary" (click)="redirectToAddUser()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="table_container">
          <table [dataSource]="dataSource" mat-table>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                        (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button mat-menu-item (click)="redirectToEditUser(row?.userId)">
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="redirectToPartnerDashboard(row?.userId)">
                            <span>Partner Dashboard</span>
                        </button>
                        <button mat-menu-item (click)="resetPartnerPassword(row?.userId)">
                          <span>Reset Password</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let element">
                  {{commonService.getRolesAsString(element?.newRole)}}
                </td>
            </ng-container>
          <ng-container matColumnDef="onlineAccess">
            <th mat-header-cell *matHeaderCellDef>Online Access</th>
            <td mat-cell *matCellDef="let element">
                <div [ngClass]="!!(element?.onlineAccess)  ? 'available' : 'unAvailable'">
                </div>
            </td>
        </ng-container>

            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef>First Name</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.firstName}}
                </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef>Last Name</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.lastName}}
                </td>
            </ng-container>
            <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef>Email Address</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.emailAddress}}
                </td>
            </ng-container>
            <ng-container matColumnDef="mobileNumber">
                <th mat-header-cell *matHeaderCellDef>Mobile No</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.phoneNumber | mask : "(000) 000-0000"}}
                </td>
            </ng-container>
            
            <ng-container matColumnDef="leadSources">
              <th mat-header-cell *matHeaderCellDef>Lead Sources</th>
              <td mat-cell *matCellDef="let element">
                  {{element?.leadSources?.toString()}}
              </td>
          </ng-container>
            <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: visibleColumns"
                class="clickable route-animations-elements" mat-row>
            </tr>
          </table>
        </div>
       
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
          No User found.
      </div>
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 2000]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
            showFirstLastButtons
            [selectConfig] = "selectConfig"
            [ngClass]="{'mat-pegig': pageSize === 2000}"
            aria-label="Select page of periodic elements">
        </mat-paginator>
       
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  
